import PropTypes from 'prop-types'
import classNames from 'classnames'
import $ from 'jquery'
import defer from 'lodash/defer'
import React, { Component } from 'react'
import IScroll from 'iscroll-lite'

class Scroller extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
    horizontal: PropTypes.bool,
  }

  static defaultProps = {
    horizontal: false,
  }

  // Lifecycle Methods

  componentDidMount() {
    $(`#${this.props.id}`).on('touchmove', e => {
      e.preventDefault()
    })

    this.enableScrolling()
    // Refresh every 500ms because children dynamically change.
    this.refreshInterval = setInterval(this.refresh, 500)
  }

  componentWillUnmount() {
    this.disableScrolling()
    $(`#${this.props.id}`).off('touchmove')
    clearInterval(this.refreshInterval)
  }

  // State / Prop Accessors

  enableScrolling = () => {
    this.disableScrolling()

    setTimeout(() => {
      const scrollerElement = document.querySelector(`#${this.props.id}`)

      if (scrollerElement) {
        this.scroller = new IScroll(scrollerElement, {
          bounceTime: 500,
          bounceEasing: 'quadratic',
          deceleration: 0.001,
          // The following two options work around an iScroll bug that prevents
          // certain form events from firing. More information here:
          // https://github.com/cubiq/iscroll/issues/576
          click: false,
          preventDefaultException: { tagName: /.*/ },
          scrollX: this.props.horizontal,
          scrollY: !this.props.horizontal,
          eventPassthrough: this.props.horizontal,
        })
      }
    })
  }

  disableScrolling = () => {
    this.scroller && this.scroller.destroy()
    this.scroller = null
  }

  refresh = () => {
    defer(() => {
      this.scroller && this.scroller.refresh()
    })
  }

  // Event Handling

  scrollToElement = element => {
    defer(() => {
      this.scroller && this.scroller.scrollToElement(element)
    })
  }

  onScrollEnd = onScrollEnd => {
    defer(() => {
      this.scroller && this.scroller.on('scrollEnd', onScrollEnd)
    })
  }

  // Rendering

  render() {
    const className = classNames(this.props.className, 'scroller')
    const style = this.props.horizontal ? {} : { position: 'relative', height: '100%' }

    return (
      <div id={this.props.id} className={className} style={style}>
        {this.props.children}
      </div>
    )
  }
}

export default Scroller
